import styled from 'styled-components';
import PythonPlayground from '../../PythonPlayground';
import { Label, NonCopyableMarkdown, SectionWrapper } from '../common';
import { AssessmentTestContextType } from '../../../contexts/assessment-test';
import { AssessmentTestContext } from '../../../contexts/assessment-test';
import React from 'react';
import FollowUp from './FollowUp';

const PlaygroundWrapper = styled.div`
  height: 78vh;
  margin-top: 24px;
  padding-bottom: 12px;
  .py-playground-wrapper {
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.colors.bgActive};
    /* background-color: ${({ theme }) => theme.colors.bgDefaultSecondary}; */
    background-color: ${({ theme }) => theme.colors.inputBackground};
    .ace_scrollbar {
      scrollbar-width: thin;
    }
  }

  .ace_content,
  .ace_edior .ace_scroller,
  .ace_scrollbar,
  .ace_text-input,
  .python-editor {
    overscroll-behavior: contain;
  }

  .py-playground-header {
    background-color: #161617;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .py-playground-terminal {
    background-color: #161617;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  .ace_content {
    user-select: none;
  }
`;

export default function PythonPlaygroundSection({
  stepId,
  section,
}: {
  section: Extract<
    AssessmentTestContextType['steps'][number]['sections'][number],
    { type: 'py-playground' }
  >;
  stepId: string;
}) {
  const { setupCode, content, startingCode } = section;
  const { code, output } = section.answer;
  const [, dispatch] = React.useContext(AssessmentTestContext);

  const onCodeChange = (code: string) => {
    dispatch({
      type: 'CHANGE_ANSWER_PY_PLAYGROUND',
      payload: { stepId, sectionId: section.id, answer: { output, code } },
    });
  };

  const onResult = ({ result, code }: { result: string; code: string }) => {
    dispatch({
      type: 'CHANGE_ANSWER_PY_PLAYGROUND',
      payload: {
        stepId,
        sectionId: section.id,
        answer: { output: result, code },
      },
    });
  };

  const onResetCode = () => {
    dispatch({
      type: 'CHANGE_ANSWER_PY_PLAYGROUND',
      payload: {
        stepId,
        sectionId: section.id,
        answer: { output, code: startingCode },
      },
    });
  };

  return (
    <SectionWrapper>
      <NonCopyableMarkdown md={content} />
      <PlaygroundWrapper>
        <PythonPlayground
          shouldDisalePaste
          setupPy={setupCode}
          code={code}
          onCodeChange={onCodeChange}
          onResult={onResult}
          onResetCode={onResetCode}
          isRunOnly
        />
      </PlaygroundWrapper>
      <Label>Write your answer in the code editor.</Label>
      <FollowUp section={section} stepId={stepId} />
    </SectionWrapper>
  );
}
